module.exports = __webpack_public_path__ + "img/zhangpeiheng.d7ef8248.png";